<label
  [translatable]="{
    transKey: labelTranslationKey,
    modEnum: labelTranslationModuleEnum
  }"
  class="form-label mt-3"
>
  {{ title }}
  <span *ngIf="isRequired" class="astrix-red">*</span>
</label>

<div class="input-wrapper" (click)="log()">
  <ul
    class="uploaded-files"
    *ngIf="!!uploadedFiles && uploadedFiles?.length > 0"
  >
    <li *ngFor="let file of uploadedFiles; let i = index">
      <div class="file-details width-60">
        <i [class]="'bx ' + 'bxs-file-' + file?.extension"></i>
        <div>
          <span class="name" [title]="file?.name">
            {{
              file?.name?.length > 21
                ? file?.name?.slice(0, 21).concat("...")
                : file?.name
            }}
          </span>
          <span class="size">{{ file?.size }}MB</span>
        </div>
      </div>
      <div class="buttons width-30">
        <button
          (click)="onDeleteFile(i)"
          class="file-delete-btn"
          [disabled]="file.loading"
        >
          <i *ngIf="!file.loading" class="bx bx-trash"></i>
          <i *ngIf="file.loading" class="bx bx-loader-alt bx-spin"></i>
        </button>
        <button
          (click)="onViewLocalFile(i)"
          class="file-view-btn"
          [disabled]="file.loading"
        >
          <i *ngIf="!file.loading" class="bx bx-show"></i>
          <i *ngIf="file.loading" class="bx bx-loader-alt bx-spin"></i>
        </button>
      </div>
    </li>
  </ul>
  <ul
    class="uploaded-files"
    *ngIf="!!_prevAttachment && _prevAttachment?.length > 0"
  >
    <li *ngFor="let file of _prevAttachment; let i = index">
      <div class="file-details width-60">
        <i [class]="'bx ' + 'bxs-file-' + file?.extension"></i>
        <div>
          <span class="name" [title]="file?.fileName">
            {{
              file?.fileName?.length > 21
                ? file?.fileName?.slice(0, 21).concat("...")
                : file?.fileName
            }}
          </span>
          <!-- <span class="size">{{ file?.size }}MB</span> -->
        </div>
      </div>
      <div class="buttons width-30">
        <button
          (click)="onDeletePrevFile(i)"
          class="file-delete-btn"
          [disabled]="file.loading"
        >
          <i *ngIf="!file.loading" class="bx bx-trash"></i>
          <i *ngIf="file.loading" class="bx bx-loader-alt bx-spin"></i>
        </button>
        <button
          (click)="onViewLocalFile(i)"
          class="file-view-btn"
          [disabled]="file.loading"
        >
          <i *ngIf="!file.loading" class="bx bx-show"></i>
          <i *ngIf="file.loading" class="bx bx-loader-alt bx-spin"></i>
        </button>
      </div>
    </li>
  </ul>
  <div class="upload-file-btn">
    <label
    [translatable]="{
      transKey: 'shared.uploadFiles',
      modEnum: translationModulesEnum.shared
    }" [for]="uplodFileId" [class.disabled]="disabled">
      {{ "shared.uploadFiles" | translate }}
    </label>
    <input
      [id]="uplodFileId"
      #fileUpload
      (input)="onUploadFile($event)"
      type="file"
      [accept]="accept"
      [disabled]="disabled"
    />
  </div>
  <span class="upload-hint">
    {{ "shared.maxFileSixe1" | translate }} {{ maxSize }}
    {{ "shared.maxFileSixe2" | translate }}
    <span *ngFor="let type of accept?.split(','); let last = last">
      {{ " " + (type | translate) }}
      <span *ngIf="!last">,</span>
    </span>
  </span>
</div>
<p
  class="upload-hint"
  *ngIf="hint"
>
  {{ "shared.hint" | translate }}: {{ hint }}
</p>
